var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { UnifiedRestServiceBase } from "./ExpAPIVUnified.resource.js";
import { buildOdataQuery } from "@ane/core/lib/utils/ODataUtils";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let ExperimentOperationSetResource = class extends UnifiedRestServiceBase {
  constructor() {
    super("operation-sets");
  }
  getByFeatureIdAsync(workspaceId, featureId) {
    return this._get(
      buildOdataQuery(
        {
          filter: `Feature/Id eq ${featureId}`
        },
        {
          baseUrl: this.getResourceUrl(workspaceId),
          additionalQueryParams: this.getDefaultQueryParams()
        }
      )
    );
  }
  /**
   * Executes the given experiment operation set
   * @param workspaceId The workspace id.
   * @param id The experiment operation set id.
   * @returns The experiment operation set.
   */
  executeAsync(workspaceId, id) {
    return this._post(
      void 0,
      buildOdataQuery(void 0, {
        baseUrl: this.getResourceUrl(workspaceId, id) + ":execute",
        additionalQueryParams: this.getDefaultQueryParams()
      })
    );
  }
  /**
   * Executes an operation set by a list of operations.
   * @param workspaceId The workspace id.
   * @param operations The set of operations to execute.
   * @returns The experiments affected by these operations.
   */
  executeByOperationsAsync(workspaceId, operations) {
    return this._post(
      operations,
      buildOdataQuery(void 0, {
        baseUrl: this.getResourceUrl(workspaceId) + ":execute",
        additionalQueryParams: this.getDefaultQueryParams()
      })
    );
  }
  /**
   * Executes the given experiment operation set for Emergency Shutdown.
   * @param workspaceId The workspace id.
   * @param id The experiment operation set id.
   * @returns The experiment operation set.
   */
  executeEmergencyShutdownAsync(workspaceId, id) {
    return this._post(
      void 0,
      buildOdataQuery(void 0, {
        baseUrl: this.getResourceUrl(workspaceId, id) + ":execute-emergency-shutdown",
        additionalQueryParams: __spreadProps(__spreadValues({}, this.getDefaultQueryParams()), {
          "api-version": "2024-10-01-preview"
        })
      })
    );
  }
  /**
   * Executes an operation set by a list of operations for Emergency Shutdown.
   * @param workspaceId The workspace id.
   * @param operations The set of operations to execute.
   * @returns The experiments affected by these operations.
   */
  executeEmergencyShutdownByOperationsAsync(workspaceId, operations) {
    return this._post(
      operations,
      buildOdataQuery(void 0, {
        baseUrl: this.getResourceUrl(workspaceId) + ":execute-emergency-shutdown",
        additionalQueryParams: __spreadProps(__spreadValues({}, this.getDefaultQueryParams()), {
          "api-version": "2024-10-01-preview"
        })
      })
    );
  }
  getOperationCheckByOperationSetIdAsync(workspaceId, id) {
    return this._get(
      buildOdataQuery(void 0, {
        baseUrl: `${this.getResourceUrl(workspaceId, id)}/operation-check`,
        additionalQueryParams: __spreadProps(__spreadValues({}, this.getDefaultQueryParams()), {
          "api-version": "2024-10-01-preview"
        })
      })
    );
  }
  getOperationCheckByOperations(workspaceId, operations) {
    return this._post(
      operations,
      buildOdataQuery(void 0, {
        baseUrl: `${this.getResourceUrl(workspaceId)}:operation-check`,
        additionalQueryParams: __spreadProps(__spreadValues({}, this.getDefaultQueryParams()), {
          "api-version": "2024-10-01-preview"
        })
      })
    );
  }
};
ExperimentOperationSetResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], ExperimentOperationSetResource);
const ExperimentOperationSetResourceInstance = new ExperimentOperationSetResource();
export {
  ExperimentOperationSetResource,
  ExperimentOperationSetResourceInstance as default
};
//# sourceMappingURL=ExperimentOperationSet.resource.js.map
